export default () => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="4987"
    >
      <path d="M232 392L512 672l280-280z" fill="#707070" p-id="4988"></path>
    </svg>
  );
};
